<template>
  <img :src="src" @error="imgOnError" />
</template>
<script>
export default {
  name: "custom-image",
  props: {
    src: "",
    defaultSrc: "",
  },
  methods: {
    imgOnError(e) {
      let img = e.srcElement;
      img.src = this.defaultSrc;
      img.onerror = null; //防止闪图
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/custImage/index.vue